import axios from 'axios'
import qs from 'qs'

var instance = axios.create({
    baseURL: process.env.API_ROOT, 
    timeout: 30 * 1000
  })
  // axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] ='application/json;charset=UTF-8'


// 添加请求拦截器
instance.interceptors.response.use(
    response => {
        let res = {};
        res.status = response.status;
        res.data = response.data;
        return res;
    },
    error => {
        if (error.response && error.response.status == 404) {
            //跳转到xx页面
            console.log("404错误")
        }
        return Promise.reject(error.response)
    }
)


  var httpRequest = {
    // get请求
    get (url, params) {
      return new Promise((resolve, reject) => {
        instance({
          method: 'get',
          url: url,
          params: params
        }).then(response => {
          // 请求成功
          resolve(response)
        }).catch(err => {
          // 请求失败
          console.log('请求失败')
          reject(err)
        })
      })
    },
    // post请求
    post (url, params) {
      return new Promise((resolve, reject) => {
        instance({
          method: 'post',
          url: url,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          // data:params
          data: JSON.stringify(params)
          // data: qs.stringify(params)
        }).then(response => {
          // 请求成功
          resolve(response)
        }).catch(err => {
          // 请求失败
          console.log('请求失败')
          reject(err)
        })
      })
    }
  }
  
  export default httpRequest



// WEBPACK FOOTER //
// ./src/request/http.js